(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxDefineNetwork(
    $timeout, $filter, toastr, $http, UnknownNetworkListPaging, SitesListPaging, SitesProviderService,
    WorkstationListPaging, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/deployAssistant/defineNetwork/defineNetwork.template.html',
      link: function(scope) {


        function NetworkDefinitionFormController () {
          this.gwIp = null
          this.gwMac = null

          this.gatewayMethod = 'SPECIFIC_COMPUTER'
          this.networkMethod = 'CREATE_NETWORK'

          this.convertPrintQueues = false
          this.addToSite = false

          this.disableForm = false
          this.gatewayInputValid = false
          this.networkInputValid = false
          this.siteInputValid = false
          this.networkDefinitionValid = false

          this.workstation = null
          this.unknownNetwork = null
          this.network = null
          this.site = null

          this.siteNetworkConflict = false
          this.gatewayNetworkConflict = false

          this.changeGatewayMethod = () => {
            this.workstation = null
            this.unknownNetwork = null
            this.gwIp = null
            this.gwMac = null
            this.checkForSiteNetworkConflict()
            this.checkForGatewayNetworkConflict()
            this.validateNetworkDefinition()
          }

          this.changeNetworkMethod = () => {
            this.network = null
            this.convertPrintQueues = false
            this.checkForSiteNetworkConflict()
            this.checkForGatewayNetworkConflict()
            this.validateNetworkDefinition()
          }

          this.resetSite = () => {
            this.site = null
            this.checkForSiteNetworkConflict()
            this.validateNetworkDefinition()
          }


          this.resetToDefault = () => {
            // if I want to cancel
          }

          this.validateNetworkDefinition = () => {
            if (this.gwIp && this.gwMac) {
              this.gatewayInputValid = true
            } else {
              this.gatewayInputValid = false
            }

            switch (this.networkMethod) {
              case 'CREATE_NETWORK':
                if (this.network && this.network.info.name) {
                  this.networkInputValid = true
                } else {
                  this.networkInputValid = false
                }
              break;
              case 'USE_EXISTING_NETWORK':
                if (this.network && this.network.info._links.self.href) {
                  this.networkInputValid = true
                } else {
                  this.networkInputValid = false
                }
              break;
            }

            if (this.addToSite && this.site) {
              this.siteInputValid = true
            } else {
              this.siteInputValid = false
            }

            if (this.gatewayInputValid && this.networkInputValid && !this.addToSite) {
              this.networkDefinitionValid = true
            } else if (this.gatewayInputValid && this.networkInputValid && this.addToSite && this.site) {
              this.networkDefinitionValid = true
            } else {
              this.networkDefinitionValid = false
            }

          }

          this.setResource = (type, resource) => {
            switch(type) {
              case 'GATEWAY':
                this.setGateway(resource)
              break;
              case 'NETWORK':
                this.setNetwork(resource)
              break;
              case 'SITE':
                this.setSite(resource)
              break;
            }

            this.clearSelectBox()
          }

          this.clearSelectBox = () => {
            scope.unknownNetworkListPaging = null
            scope.sitesListPaging = null
            scope.workstationListPaging = null
            scope.networkSelectorIsOpen = false;
          }

          this.setGateway = (gatewayResource) => {
            switch (this.gatewayMethod) {
              case 'SPECIFIC_COMPUTER':
                this.workstation = gatewayResource ? gatewayResource : null
                this.gwIp =  this.workstation ? this.workstation.info._embedded.adapters[0].gateway.ip : null
                this.gwMac = this.workstation ? this.workstation.info._embedded.adapters[0].gateway.mac : null
              break;
              case 'UNKNOWN_NETWORK':
                this.unknownNetwork = gatewayResource ? gatewayResource : null
                this.gwIp = this.unknownNetwork ? this.unknownNetwork.gwIp : null
                this.gwMac = this.unknownNetwork ? this.unknownNetwork.gwMac : null
              break;
              case 'ADD_GATEWAY_MANUALLY':
                if (gatewayResource && gatewayResource.valid === true) {
                  this.gwIp = gatewayResource.gwIp
                  this.gwMac = gatewayResource.gwMac
                } else {
                  this.gwIp = null
                  this.gwMac = null
                }
              break;
            }
            this.checkForGatewayNetworkConflict()
            this.validateNetworkDefinition()
          }

          this.setNetwork = (networkResource) => {
            switch (this.networkMethod) {
              case 'CREATE_NETWORK':
                if (networkResource) {
                  this.network = {
                    info: {
                      name: networkResource ? networkResource : null
                    }
                  }
                } else {
                  this.network = null
                }
              break;
              case 'USE_EXISTING_NETWORK':
                this.network = networkResource ? networkResource : null
                if (this.network && this.network.info._links['px:site']) {
                  let that = this
                  SitesProviderService.getSite(this.network.info._links['px:site'].href).then(function(site) {
                    that.network.info.site = site
                    that.validateNetworkDefinition()
                    that.checkForSiteNetworkConflict()
                    that.checkForGatewayNetworkConflict()
                  }).catch(function(error) {})
                  this.checkForSiteNetworkConflict()
                  this.checkForGatewayNetworkConflict()
                } else {
                  this.validateNetworkDefinition()
                  this.checkForSiteNetworkConflict()
                  this.checkForGatewayNetworkConflict()
                }
              break;
            }

            this.validateNetworkDefinition()
          }

          this.setSite = (siteResource) => {
            this.site = siteResource ? siteResource : null

            if (this.site) {
              let that = this
              SitesProviderService.getSite(siteResource.links.self.href).then(function(site) {
                that.site = site
                that.validateNetworkDefinition()
                that.checkForSiteNetworkConflict()
              }).catch(function(error) {});
            } else {
              this.validateNetworkDefinition()
              this.checkForSiteNetworkConflict()
            }
          }

          this.checkForSiteNetworkConflict = () => {
            if (this.network && this.network.info && this.network.info._links && this.network.info._links['px:site']) {
              this.siteNetworkConflict = true
              this.validateNetworkDefinition()
            } else {
              this.siteNetworkConflict = false
              this.validateNetworkDefinition()
            }
          }

          this.checkForGatewayNetworkConflict = () => {
            if (this.networkMethod === 'USE_EXISTING_NETWORK' && this.network) {
              this.network.info.gateways.forEach((gateway) => {
                if (this.gwIp === gateway.ip && this.gwMac === gateway.mac) {
                  gateway.conflict = true
                } else {
                  gateway.conflict = false
                }
              })
              const conflict = (gateway) => { return gateway.conflict }
              this.gatewayNetworkConflict = this.network.info.gateways.some(conflict)
            } else if (this.networkMethod === 'USE_EXISTING_NETWORK' && !this.network) {
              this.gatewayNetworkConflict = false
            } else {
              this.gatewayNetworkConflict = false
            }
          }
        }

        scope.me = $rootScope.currentUser;

        (function() {
          scope.networkDefinition = new NetworkDefinitionFormController();
          getUnknownNetworkStatus();
        })();

        function getUnknownNetworkStatus () {
          var url = scope.tenant.info._links['px:unknownNetworksStatus'].href;
          $http.get(url).then(function(response) {
            checkUnknownNetworkStatus(response.data);
          }).catch(function(error) {
            console.log(error);
          });
        }

        function checkUnknownNetworkStatus (buildStatus) {
          if (buildStatus.rebuildStarted) {
            var buildStart = new Date(buildStatus.rebuildStarted).getTime();
            var currentTime = new Date().getTime();
            var difference = currentTime - buildStart;
            if (difference > 7200000) {
              buildUnknownNetworks(buildStatus);
            }
          }

          if (!buildStatus.rebuildStarted  ) {
            buildUnknownNetworks(buildStatus);
          }

          if (buildStatus.buildTime && !buildStatus.rebuildStarted) {

          }
        }

        function buildUnknownNetworks (buildStatus) {
          var url = buildStatus._links['px:rebuild'].href;

          $http.get(url).then(function(response) {
          }).catch(function(error) {
            console.log(error);
          });
        }

        scope.selectGatewayPaginated = function () {
          scope.unknownNetworkListPaging = new UnknownNetworkListPaging();
        }

        scope.selectSitePaginated = function () {
          scope.sitesListPaging = new SitesListPaging();
          scope.sitesListPaging.pagingCriteria.page = 0;
          scope.sitesListPaging.pagingCriteria.pageSize = 20;
          scope.sitesListPaging.pagingCriteria.type = 'SINGLE';
        }

        scope.selectWorkstationGatewayPaginated = function () {
          scope.workstationListPaging = new WorkstationListPaging();
        }

        scope.selectNetworkPaginated = function () {
          scope.networkSelectorIsOpen = true;
        }

        scope.save = function (event, context, menuOption, mappedNetworks) {
          scope.networkDefinition.disableForm = true;
          $timeout(function  () {
            if (event, context, menuOption) {
              scope.selectedContextMenuItem  =  menuOption;
              scope.contextPosition =  { left: event.clientX, top: event.clientY };
              scope.context = context;
              scope.context.networkDefinition = scope.networkDefinition;
            }
          }, 50)
        }

        scope.closeAllMenues = function () {
          scope.suppressSaveButton = false;
          scope.selectedContextMenuItem  =  null;
          scope.contextPosition = null;
          scope.context = null;

          scope.networkDefinition = new NetworkDefinitionFormController();


        }

        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch(tooltipScope) {
              case 'gatewayConflict':
                gatewayConflictTooltip(position, context);
              break;
              case 'siteConflict':
                siteConflictTooltip(position, context);
              break;
            }
          } else {
            scope.clearTooltip();
          }
        }

        function gatewayConflictTooltip (position, context) {

          scope.clearTooltip();
          scope.tooltipContent = {
            title: 'Conflict',
            networkDefinition: context,
            type: 'gatewayConflict',
          }

          scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20}
          }
        }

        function siteConflictTooltip (position, context) {

          scope.tooltipContent = {
            title: 'Conflict',
            networkDefinition: context,
            type: 'siteConflict',
          }

          scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20}
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }


      }
    };
  }

  pxDefineNetwork.$inject = [
    '$timeout', '$filter', 'toastr', '$http', 'UnknownNetworkListPaging', 'SitesListPaging', 'SitesProviderService',
    'WorkstationListPaging', '$rootScope'
  ];

  angular
    .module('printix-admin')
    .directive('pxDefineNetwork', pxDefineNetwork);

})();
